<template>
  <FullScreenOverlay
    v-model="dialog"
    v-model:index="currentIndex"
    :item-count="photos.length"
  >
    <template #default>
      <FullScreenOverlayItem
        v-for="(photo, index) in photos"
        :key="photo.slug"
        :index="index"
      >
        <template #default>
          <PhotoFullscreen :photo="photo" :visible="index === currentIndex" />
        </template>
      </FullScreenOverlayItem>
    </template>

    <template #download>
      <a :href="url" :download="downloadFilename" v-if="allowDownload">
        <ArrowDownIcon class="w-8 h-8" />
      </a>
    </template>
  </FullScreenOverlay>
</template>

<script lang="ts" setup>
import type { Photo } from "~/api";
import { ArrowDownIcon } from "@heroicons/vue/20/solid";

const router = useRouter();
const dialog = defineModel<boolean>({ default: false });
const currentIndex = defineModel("index", { type: Number, required: true });

const props = defineProps({
  photos: {
    type: Object as PropType<Photo[]>,
    required: true,
  },
  allowDownload: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});

// const router = useRouter();
const { photos } = toRefs(props);
const selectedPhoto = computed(() => photos.value[currentIndex.value]);
const { url, downloadFilename } = usePhoto(selectedPhoto, 4000);

watch(selectedPhoto, (photo) => {
  router.replace({ hash: `#${photo.slug}` });
  // window.location.hash = photo.slug;
});

watch(dialog, (dialog) => {
  if (!dialog) {
    // blanking the hash causes a scroll to top
    router.replace({ hash: "#_" });
    // window.location.hash = "_";
  }
});

// Do we have a hash already at page load?  Then find the photo and display it.
const route = useRoute();
const hash = route.hash;

if (hash) {
  // #dfasdfasc => abc
  const slug = hash.slice(1);
  const index = photos.value.findIndex((photo) => photo.slug === slug);
  if (index >= 0) {
    dialog.value = true;
    currentIndex.value = index;
  }
}
</script>
